import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useDiscountCardInformationSection} from '../hooks/useGetBasketPageSection';
import {BasketDiscountCardInformationSectionView} from './BasketDiscountCardInformationSectionView';
export const BasketDiscountCardInformationSection = () => {
  return (
    <DataFetcher
      request={useDiscountCardInformationSection()}
      Loading={() => null}
      Error={() => null}
      View={BasketDiscountCardInformationSectionView}
    />
  );
};
